/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PartnerRegion } from '../../models/partner-region';

export interface GetPartnerRegion$Params {
  id: string;
}

export function getPartnerRegion(http: HttpClient, rootUrl: string, params: GetPartnerRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerRegion>> {
  const rb = new RequestBuilder(rootUrl, getPartnerRegion.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartnerRegion>;
    })
  );
}

getPartnerRegion.PATH = '/partnerregion/{id}';
